export const PARAM_CATEGORY_ID = 'category_id';
export const PARAM_EXCLUDE_FOLLOWED = 'exclude_followed';
export const PARAM_FOLLOWED_BY_USER = 'followed_by_user';
export const PARAM_OTHER_TOPICS = 'other_topics';
export const PARAM_SUGGESTED_FOR_USER = 'suggested_for_user';
export const PARAM_SUPER_CATEGORY_ID = 'super_category_id';
